<template>
	<div id="main">

		<div class="sku-box store-content ">
			<!---->
			<div class="gray-box">
				<header class="title-header">
					<h5 class="title">下载中心</h5>
				</header>
				<div class="item-box" style="height: 400px;padding: 40px 80px 0 80px;">

					<table>
						<thead>
							<tr>
								<th style="width: 70%;">
									文件名称
								</th>
								<th style="width: 30%;">
									下载
								</th>
							</tr>
						</thead>
						<tbody class="m-body">
							<tr v-for="(item, index) in productsData" :key="index">
								<td style="width: 70%;">
									<span >{{ item.name }}</span>
								</td>
								<td  style="width: 30%;">
									<button @click="download(item.name)" style="width: 80px;height:25px;border: 1px solid gray;">下载文件</button>
								</td>
							</tr>
						</tbody>
					</table>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import productsData from '@/lib/downloadData.js';

	export default {
		data() {
			return {
				productsData
			};
		},
		methods: {
			download(fileName) {
				//let url = 'http://192.168.3.159/Public/download/' + fileName;
                let url =     this.$store.state.pdfUrl+'download/' + fileName;
				//let url = '@/assets/word/resource.pdf' ;
				//				this.$download(url,fileName);
				console.log(url);
				window.open(url);
				//				let link = document.createElement('a');								
				//				link.href = url;
				//				link.setAttribute('download', fileName);
				//				link.click();
			}

		},
		mounted() {
			//const files = require.context('@/assets/word', false, /.pdf$/).keys();
			// require.context('需要读取的文件路径', false, /.svg$/)
			// require.context接收三个参数，第一个是文件路径，第二个是是否读取子文件。false不读取， 第三个参数
			// 是个正则表达式： .svg匹配以.svg文件结尾的文件
			//console.log(files);
		},
		components: {
			//axios
		}
	}
</script>

<style>

table {
    table-layout: fixed;
    width: 100%;
    text-align: center;
    border-radius: 4px 4px 0 0;
    border-collapse: separate;
    border-spacing: 0;
}
thead tr th {
      padding: 16px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      text-align: center;
      background: #fafafa;
      border: 1px solid #e8e8e8;
      transition: background .3s ease;
      &:first-child {
        border-top-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
      }
    }

    td {
        padding: 5px 16px 5px 16px;
        border: 1px solid #e8e8e8;
        transition: background .3s;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

</style>


// WEBPACK FOOTER //
// src/views/PageDownload.vue